export const config = {
  toolbar: {
    items: [
      "heading",
      "fontfamily",
      "fontsize",
      "fontColor",
      "fontBackgroundColor",
      "|",
      "bold",
      "italic",
      "strikethrough",
      "underline",
      "blockQuote",
      "|",
      "link",
      "|",
      "alignment:left",
      "alignment:right",
      "alignment:center",
      "alignment:justify",
      "outdent",
      "indent",
      "|",
      "bulletedList",
      "numberedList"
    ],
    shouldNotGroupWhenFull: true
  },
  link: {
    addTargetToExternalLinks: true
  },
  heading: {
    options: [
      { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
      {
        model: "heading1",
        view: {
          name: "h1",
          classes: ["heading1"] // Use array to specify multiple classes
        },
        title: "Heading 1",
        class: "ck-heading_heading1",
        converterPriority: "high"
      },
      {
        model: "heading2",
        view: {
          name: "h2",
          classes: ["heading2"] // Use array to specify multiple classes
        },
        title: "Heading 2",
        class: "ck-heading_heading2",
        converterPriority: "high"
      },
      {
        model: "heading3",
        view: {
          name: "h3",
          classes: ["heading3"] // Use array to specify multiple classes
        },
        title: "Heading 3",
        class: "ck-heading_heading3",
        converterPriority: "high"
      },
      {
        model: "heading4",
        view: {
          name: "h4",
          classes: ["heading4"] // Use array to specify multiple classes
        },
        title: "Heading 4",
        class: "ck-heading_heading4",
        converterPriority: "high"
      }
    ]
  }
};
